import { ColorType } from '@components-library/Tag/Tag';
import ENUM_TYPES from '@components-shared/enum.types';
import { getFormattedNumber } from '@utils/helper';

export const LOYALTY_PROGRAM_STATUS_COLOR: Record<ENUM_TYPES['LOYALTY_PROGRAM_STATUS'], ColorType> = {
  Finished: 'greyStatus',
  Ongoing: 'greenStatus',
  New: 'greenStatus',
};

export const POINTS_PRECISION = 2;

export const getFormattedPoints = (points: number) => {
  return getFormattedNumber(points, { precision: POINTS_PRECISION });
};

export const getLoyaltyProgramRedeemStatusColor = (
  status: ENUM_TYPES['LOYALTY_PARTICIPANT_REDEEM_STATUS'],
): ColorType => {
  switch (status as ENUM_TYPES['LOYALTY_PARTICIPANT_REDEEM_STATUS']) {
    case 'Pending':
    case 'Approving':
    case 'Rejecting':
    case 'Cancelling':
    case 'Delivering':
      return 'orangeStatus';
    case 'Approved':
    case 'Delivered':
      return 'greenStatus';
    case 'Cancelled':
    case 'Rejected':
    case 'Failed':
    case 'Undelivered':
      return 'redStatus';
    default:
      return 'greyStatus';
  }
};
